import {ReactNode} from "react";
import {FormattedMessage} from "react-intl";

type Props = {
    children?: ReactNode;
    idSuffix: string;
};

const NoDeviceBlock = ({children, idSuffix}: Props) => {
    return (
        <div style={{paddingLeft: "1.5rem", paddingBottom: "1rem"}}>
            <h3 id={`no-existing-devices-${idSuffix}`}>
                <FormattedMessage id="no_existing_device" defaultMessage="No existing device" />
            </h3>
            {children}
        </div>
    );
};

export default NoDeviceBlock;
